export enum ChallengeType {
  STANDARD = 'standard',
  FUNNEL = 'funnel',
  MILESTONE = 'milestone'
}
